<!-- @format -->

<script setup>
import { onMounted } from 'vue'
import TitleBar from './TitleBar.vue'
import client from '../utils/client'

const props = defineProps({
  title: {
    type: String,
    default: '标题',
  },
  titleColor: {
    type: String,
    default: 'white',
  },
  titleBackgroundColor: {
    type: String,
    default: 'black',
  },
  withStatus: {
    type: Boolean,
    default: true,
  },
  screenBackground: {
    type: String,
    default: 'black',
  },
  onBack: {
    type: Function,
    default: () => client.goBack(),
  },
})
onMounted(() => {
  document.body.style.backgroundColor = props.screenBackground
})
</script>
<template>
  <div class="scf_root" id="scf-root">
    <TitleBar
      :on-back="onBack"
      :title="props.title"
      :with-status="withStatus"
      :style="{ backgroundColor: titleBackgroundColor }"
      :title-color="titleColor"
      style="position: sticky; top: 0"
      id="scf-title"></TitleBar>
    <div class="scf_body" id="scf-content">
      <slot></slot>
    </div>
  </div>
</template>
<style scoped>
.scf_body {
  position: relative;
}

.scf_root {
  /* position: fixed; */
  /* position: relative; */
  width: 100%;
  height: 100%;
}
</style>
